/**
 * Timeline Icon Component
 *
 * Timeline icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/timeline-icon
 */
import { createIconNode } from '../create-icon';
const TIMELINE_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [{ d: 'M1.5 1.5V14.5M6 8.63333V7.36667C6 6.88802 6.38802 6.5 6.86667 6.5H11.1333C11.612 6.5 12 6.88802 12 7.36667V8.63333C12 9.11198 11.612 9.5 11.1333 9.5H6.86667C6.38802 9.5 6 9.11198 6 8.63333ZM8.5 13.6333V12.3667C8.5 11.888 8.88802 11.5 9.36667 11.5H13.6333C14.112 11.5 14.5 11.888 14.5 12.3667V13.6333C14.5 14.112 14.112 14.5 13.6333 14.5H9.36667C8.88802 14.5 8.5 14.112 8.5 13.6333ZM9.5 3.63333V2.36667C9.5 1.88802 9.11198 1.5 8.63333 1.5H4.36667C3.88802 1.5 3.5 1.88802 3.5 2.36667V3.63333C3.5 4.11198 3.88802 4.5 4.36667 4.5H8.63333C9.11198 4.5 9.5 4.11198 9.5 3.63333Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [{ d: 'M4.5 4.5V19.5M6.5 6.5V5.5C6.5 4.94772 6.94772 4.5 7.5 4.5H12.5C13.0523 4.5 13.5 4.94772 13.5 5.5V6.5C13.5 7.05228 13.0523 7.5 12.5 7.5H7.5C6.94772 7.5 6.5 7.05228 6.5 6.5ZM15.5 13.5H10.5C9.94772 13.5 9.5 13.0523 9.5 12.5V11.5C9.5 10.9477 9.94772 10.5 10.5 10.5H15.5C16.0523 10.5 16.5 10.9477 16.5 11.5V12.5C16.5 13.0523 16.0523 13.5 15.5 13.5ZM19.5 18.5V17.5C19.5 16.9477 19.0523 16.5 18.5 16.5H13.5C12.9477 16.5 12.5 16.9477 12.5 17.5V18.5C12.5 19.0523 12.9477 19.5 13.5 19.5H18.5C19.0523 19.5 19.5 19.0523 19.5 18.5Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' }],
    },
});
export function TimelineIcon(props) {
    return createIconNode(TIMELINE_ICON, props);
}
//# sourceMappingURL=timeline.js.map